import useSWR, { mutate } from 'swr'
import {
  createEmployeeAPI,
  getEmployeeAPI,
  getEmployeesAPI,
} from '@/lib/employee/Employee'
import { Employee } from '@/lib/employee/Employee.types'

//=====================================
// get employees
//=====================================

export const useGetEmployeesSWR = (uri: URL | RequestInfo) => {
  return useSWR(uri, getEmployeesAPI, {
    refreshInterval: 1000 * 60 * 1,
  })
}

//=====================================
// get employee
//=====================================

export const useGetEmployeeSWR = (uri: URL | RequestInfo) => {
  return useSWR(uri, getEmployeeAPI, {
    refreshInterval: 1000 * 60 * 1,
  })
}

//=====================================
// create employee
//=====================================

// @@TODO: Custom hook is cumbersome.
/*
export const useCreateEmployeeSWR = (uri: URL | RequestInfo, employee: Employee) => {
  const options = {}
  return mutate('/api/get-employee', createEmployeeAPI(uri, employee), options)
}
*/

//=====================================
// delete employee
//=====================================

//=====================================
// update employee
//=====================================

// NOTE: swr has no hooks for create / delete / update.
// swr must be informed of a change by using the "mutate" function with the correct key to trigger a refetch.
// https://swr.vercel.app
